import { ChatApiError } from '../../apiErrors'
import { frontendLanguage } from '../../i18n'

const norwegian = {
  model: 'Modell',
  title: 'Velg modell',
  admin: 'Kun admin',
  standard: 'Bruk chatbotens standardmodell',
  standardShort: 'Standard',
  test: 'Testmodell',
  unconfirmed: 'Modell ikke bekreftet',
  description: 'Systemprompt og verktøy brukes som før.',
  newConversation: 'Start ny samtale med denne modellen',
  starting: 'Starter samtale …',
  unavailable: 'Ikke tilgjengelig',
  retry: 'Prøv igjen',
  close: 'Lukk modellvelger',
  incomplete: 'Svaret er ufullstendig',
  failed: 'Svaret kunne ikke fullføres',
  connectionFailed: 'Forbindelsen ble brutt. Prøv en ny samtale.',
  requestFailed: 'Handlingen kunne ikke fullføres. Prøv igjen.',
  catalogFailed: 'Kunne ikke hente modellene.',
  backendUnavailable:
    'Modellvalg er ikke tilgjengelig i denne versjonen av tjenesten.',
  confirmationFailed: 'Kunne ikke bekrefte modellen for samtalen. Prøv igjen.',
  newThreadHint: 'Starter med tom historikk.',
  signIn: 'Logg inn på nytt for å fortsette.',
  forbidden:
    'Du mangler tilgang, eller samtalen er ikke lenger tilgjengelig. Prøv en ny samtale.',
  unknownModel: 'Modellen finnes ikke lenger. Hent modellisten på nytt.',
  conflict:
    'Modellvalget støttes ikke her. Velg modell når du starter en ny samtale.',
  invalid: 'Modellvalget kunne ikke brukes. Prøv igjen.',
  modelUnavailable:
    'Testmodellen er utilgjengelig. Prøv igjen eller velg en annen modell.',
}

const english: typeof norwegian = {
  model: 'Model',
  title: 'Choose model',
  admin: 'Admin only',
  standard: 'Use the chatbot default model',
  standardShort: 'Default',
  test: 'Test model',
  unconfirmed: 'Model not confirmed',
  description: 'System prompts and tools work as before.',
  newConversation: 'Start a new conversation with this model',
  starting: 'Starting conversation …',
  unavailable: 'Unavailable',
  retry: 'Try again',
  close: 'Close model picker',
  incomplete: 'The answer is incomplete',
  failed: 'The answer could not be completed',
  connectionFailed: 'The connection was interrupted. Try a new conversation.',
  requestFailed: 'The action could not be completed. Please try again.',
  catalogFailed: 'Could not load the models.',
  backendUnavailable:
    'Model selection is not available in this version of the service.',
  confirmationFailed:
    'Could not confirm the model for this conversation. Please try again.',
  newThreadHint: 'Starts with an empty history.',
  signIn: 'Sign in again to continue.',
  forbidden:
    'Access was denied or the conversation is no longer available. Try a new conversation.',
  unknownModel: 'This model is no longer listed. Reload the model list.',
  conflict:
    'This model selection is not supported here. Choose a model when starting a new conversation.',
  invalid: 'The model selection could not be used. Please try again.',
  modelUnavailable:
    'The test model is unavailable. Try again or select another model.',
}

// Keep admin copy local to this feature; other frontend languages use English.
export const modelTestCopy = frontendLanguage === 'no' ? norwegian : english

export function modelTestError(
  error: unknown,
  fallback = modelTestCopy.requestFailed,
): string {
  if (!(error instanceof ChatApiError)) return fallback
  const messages: Record<number, string> = {
    400: modelTestCopy.unknownModel,
    401: modelTestCopy.signIn,
    403: modelTestCopy.forbidden,
    409: modelTestCopy.conflict,
    422: modelTestCopy.invalid,
    503: modelTestCopy.modelUnavailable,
  }
  return messages[error.status] || fallback
}
